exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-warning {\r\n    color: #333;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Component/ESS-BA20GA30IGW/dse7200/dse7200.component.css
// module id = ../../../../../src/app/Component/ESS-BA20GA30IGW/dse7200/dse7200.component.css
// module chunks = main